import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import { FilterContext } from "@faire/retailer-visitor-shared/components/Filters/FilterContext";
import {
  FilterState,
  useCreateFilterStore,
} from "@faire/retailer-visitor-shared/components/Filters/FilterStore";
import { useLoggedOutSuppliersPageFilterSections } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageFilterSections";
import { useLoggedOutSuppliersPageIsPending } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { useLoggedOutSuppliersPageQueryParams } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageQueryParams";
import cloneDeep from "lodash/cloneDeep";
import React, { ReactNode, useEffect } from "react";

export const LoggedOutSuppliersPageFilterStoreProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { setFilterKeys, clearOneIndexedPageNumber } =
    useLoggedOutSuppliersPageQueryParams();
  const filterSections = useLoggedOutSuppliersPageFilterSections();
  const isLoading = useLoggedOutSuppliersPageIsPending();

  const onFilterSelected = (state: FilterState) => {
    const filterKeys = getSelectedFilterKeys(state.filterSections);
    setFilterKeys(() => filterKeys);
    clearOneIndexedPageNumber();
  };

  const filterStore = useCreateFilterStore(
    FilterState.build(),
    onFilterSelected
  );

  useEffect(() => {
    if (filterSections && filterSections.length > 0 && !isLoading) {
      filterStore.setState((currentState) => ({
        ...currentState,
        filterSections: cloneDeep(filterSections),
        isNewFilterSelected: false,
      }));
    }
  }, [filterStore, filterSections, isLoading]);

  return (
    <FilterContext.Provider value={filterStore}>
      {children}
    </FilterContext.Provider>
  );
};
